import { render, staticRenderFns } from "./TransitionRouter.vue?vue&type=template&id=1441dc9f"
import script from "./TransitionRouter.vue?vue&type=script&lang=js"
export * from "./TransitionRouter.vue?vue&type=script&lang=js"
import style0 from "./TransitionRouter.vue?vue&type=style&index=0&id=1441dc9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports